import { render, staticRenderFns } from "./ManageTop.vue?vue&type=template&id=512ec35b&scoped=true"
import script from "./ManageTop.vue?vue&type=script&lang=ts"
export * from "./ManageTop.vue?vue&type=script&lang=ts"
import style0 from "./ManageTop.vue?vue&type=style&index=0&id=512ec35b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512ec35b",
  null
  
)

export default component.exports